import { render, staticRenderFns } from "./coze.vue?vue&type=template&id=60ddf9ae&scoped=true"
import script from "./coze.vue?vue&type=script&lang=js"
export * from "./coze.vue?vue&type=script&lang=js"
import style0 from "./coze.vue?vue&type=style&index=0&id=60ddf9ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddf9ae",
  null
  
)

export default component.exports